import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin } from 'lucide-react';
import IronVisionLogo from './IronVisionLogo';

const Footer = () => {
  return (
    <footer className="relative border-t border-cyan-400/10 bg-[#070a13]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="inline-flex items-center gap-2.5">
            <IronVisionLogo size={40} />
            <span className="text-white font-bold tracking-wider text-lg">IRON<span className="text-cyan-400">VISION</span></span>
          </Link>
          <p className="mt-4 text-slate-400 text-sm max-w-md leading-relaxed">
            Cybersecurity and GRC services for the U.S. Department of Defense, Intelligence Community, and other federal and regulated organizations.
          </p>
          <div className="mt-6 space-y-2 text-sm text-slate-400">
            <p className="flex items-center gap-2"><MapPin className="w-4 h-4 text-cyan-400" /> Washington, D.C. Metro Area</p>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Company</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li><Link to="/about" className="hover:text-cyan-300">About</Link></li>
            <li><Link to="/products" className="hover:text-cyan-300">Products</Link></li>
            <li><Link to="/careers" className="hover:text-cyan-300">Careers</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Business</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li>UEI: <span className="text-slate-200">RGB4EE4995T6</span></li>
            <li>CAGE: <span className="text-slate-200">94VS2</span></li>
            <li>GSA MAS Schedule Holder</li>
            <li><a href="https://www.linkedin.com/company/ironvision/" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-300 inline-flex items-center gap-1"><Linkedin className="w-4 h-4" /> LinkedIn</a></li>
            <li><a href="/admin/login" className="hover:text-cyan-300 text-xs text-slate-500">Admin</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cyan-400/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} IronVision. All rights reserved.</p>
          <p>Privacy · Terms · Capabilities Statement</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
